import { z } from 'zod';
import { MEMBERSHIP_ROLES } from '@irl/types';
export const updateMemberRoleSchema = z.object({
    role: z.enum(MEMBERSHIP_ROLES),
});
//# sourceMappingURL=chat-members.js.map